import { Component, OnInit, ViewChild, Directive, Input, OnChanges } from '@angular/core';
import { ExclusionEquiposService } from "./solicitud-equipo.service";
import { ClienteLogin, ClienteXCiudad } from "../../login/cliente_login";
import { correctHeight, detectBody } from "../../../app.helpers";
import { SessionStorageService } from "ngx-webstorage/dist/services";
import { HandleError } from "../../../components/common/utils/handleError.component";
import { Router } from '@angular/router';
import { SessionTokenService } from "../../../components/common/utils/sessionToken.service";
import { DatosGeneralesEntity } from "../entities/datos_generales_entity";
import { ModalComponent } from "ng2-bs3-modal/ng2-bs3-modal";
import { PolizaEntity } from "../entities/polizas_cliente_entity";
import { EquipoExclusionEntity, CabeceraEquipoExclusionEntity } from "../entities/equipos_exclusion_entity";
import { FileUploader } from "ng2-file-upload/ng2-file-upload";
import { ConstantService } from "../../../components/common/utils/constant.service";
import { ExclusionOtrosService } from './solicitud-otros.service';
import { OtrosExclusionEntity } from "../entities/otros_exclusion_entity";


const swal = require("sweetalert2");

declare var jQuery: any;
@Component({
    selector: 'exclusionEquipos',
    providers: [],
    templateUrl: 'solicitud-equipo.template.html'

})

export class ExclusionEquipos implements OnChanges {
    private url = "solicitudes";
    otrosEntity: OtrosExclusionEntity;
    equipos: EquipoExclusionEntity [];
    cabEquipos: CabeceraEquipoExclusionEntity;
    usuario: ClienteLogin;
    public showLoader: string;
    opcion: number;
    @Input() polizaContratada: PolizaEntity;
    public uploaderInc: FileUploader;            
    public uploaderOtros: FileUploader;  
    equiposChk: any = {};
    devolverMensaje: any;

    constructor(
        private exclusionEquiposService: ExclusionEquiposService,
        private router: Router,
        private sessionTokenService: SessionTokenService,
        private handleError: HandleError,
        public sesionStorageService: SessionStorageService) {

        this.otrosEntity = new OtrosExclusionEntity();

        let constantService = new ConstantService();
        this.url = constantService.API_ENDPOINT + this.url;

        this.uploaderInc = new FileUploader({
            url: this.url + '/incluirOtros',
            allowedMimeType: ['image/jpeg',
                'image/png',
                'application/pdf',
                'application/msword',
                'application/vnd.ms-excel',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                'application/x-zip-compressed'
            ],
            maxFileSize: 5 * 1024 * 1024, /*limitado a 5 MB*/
            removeAfterUpload: true
        });

        this.uploaderInc.options.headers = [];

        this.uploaderInc.onAfterAddingFile = (file) => {
            file.withCredentials = false;
        };

        this.uploaderInc.onCompleteItem = (item: any, response: any, status: number, headers: any) => {
            this.devolverMensaje(status, 1);
        }
        this.uploaderOtros = new FileUploader({
            url: this.url + '/otrosMov',
            allowedMimeType: ['image/jpeg',
                'image/png',
                'application/pdf',
                'application/msword',
                'application/vnd.ms-excel',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                'application/x-zip-compressed'
            ],
            maxFileSize: 5 * 1024 * 1024, /*limitado a 5 MB*/
            removeAfterUpload: true
        });

        this.uploaderOtros.options.headers = [];

        this.uploaderOtros.onAfterAddingFile = (file) => {
            file.withCredentials = false;
        };

        this.uploaderOtros.onCompleteItem = (item: any, response: any, status: number, headers: any) => {
            this.devolverMensaje(status, 2);
        }


        this.devolverMensaje = (parametro: number, tipoSolicitud: number): void => {

            let textoSolicitud = "";

            if (tipoSolicitud == 1)
                textoSolicitud = "inclusión";
            else
                textoSolicitud = "otros movimientos";


            if (parametro == 200) {
                swal({
                    title: 'Solicitud de ' + textoSolicitud + ' de bien asegurado',
                    text: 'Su solicitud ha sido enviada exitosamente. En breve, un ejecutivo se comunicará con ud. para concluir el proceso.',
                    type: 'success',
                    confirmButtonColor: '#A14950',
                    confirmButtonText: 'Aceptar'
                }).then(function () {
                    window.location.reload(true);
                });
            }
            else {
                swal({
                    title: 'Error en solicitud de ' + textoSolicitud,
                    text: 'No se pudo realizar el envío de la solicitud de ' + textoSolicitud + ', por favor vuelva a intentar. En caso de volver a presentarse el mismo mensaje repórtelo a su ejecutivo de cuenta.',
                    type: 'error',
                    confirmButtonColor: '#A14950',
                    confirmButtonText: 'Aceptar'
                })
            }
        }

         }

  noSeleccionado() {
      //[disabled]="!noSeleccionado()"
      //return !this.items.some(item=>item.chosen);
    //return !this.vehiculosChk.some(veh => veh.CodigoVehiculo);
  }

    excluirEquiposSeleccionados() {

    let cabEquipos = new CabeceraEquipoExclusionEntity();

        Object.keys(this.equiposChk).forEach((item, index) => {
            if (this.equiposChk[item]) {
                (this.equipos).forEach(x => {
                    if (x.CodigoEquipo.toString() == item) {
                        //x.CodigoUsuario = this.usuario.CodigoUsuario;
                        x.EstadoSolicitud = 1;
                    }
                });
            }
        }
        );

        cabEquipos.CodigoAseguradora = this.polizaContratada.CodigoAseguradora;
        cabEquipos.CodigoCiudad = this.polizaContratada.CodigoCiudad;
        cabEquipos.CodigoCliente = this.polizaContratada.CodigoCliente;
        cabEquipos.CodigoPoliza = this.polizaContratada.CodigoPoliza;
        cabEquipos.CodigoRamo = this.polizaContratada.CodigoRamo;
        cabEquipos.CodigoAseguradora = this.polizaContratada.CodigoAseguradora;
        cabEquipos.CodigoUnidad = this.polizaContratada.CodigoUnidad;
        cabEquipos.RolEmpleado = this.polizaContratada.RolEmpleado;        
        cabEquipos.CodigoUsuario = this.usuario.CodigoUsuario;
        cabEquipos.EquipoExclusion = (this.equipos).filter(v => v.EstadoSolicitud == 1);

        this.exclusionEquiposService.excluirEquipos(cabEquipos).subscribe(
            result => {
                if (result) {
                    swal({
                        title: 'Exclusión',
                        text: "Ha solicitado la exclusión de los items seleccionados, pronto se comunicará con ud. su ejecutivo para completar el proceso",
                        type: 'success'
                    }).then(function () {
                        window.location.reload(true);
                    });
                } else {
                    swal({
                        title: 'Exclusión',
                        text: "A ocurrido un inconveniente al intentar enviar su solicitud",
                        type: 'warning'
                    }).then(function () {
                        this.router.navigate(["/error/500"]);
                    });
                }
            },
            error => { this.handleError.redirectUrl(error); }
        );        
    }

    uploadFilesInQueue(tipoSolicitud: number): void {

        if (tipoSolicitud == 1) //inclusión
        {
            if (this.uploaderInc.getNotUploadedItems().length == 1) {

                this.uploaderInc.options.headers.push(
                    { name: 'Authorization', value: 'Token ' + this.sesionStorageService.retrieve("Token") },
                    { name: 'CodigoUsuario', value: this.usuario.CodigoUsuario + "" },
                    { name: 'CodigoCiudad', value: this.otrosEntity.CodigoCiudad + "" },
                    { name: 'CodigoCliente', value: this.otrosEntity.CodigoCliente + "" },
                    { name: 'CodigoPoliza', value: this.otrosEntity.CodigoPoliza + "" },
                    { name: 'RolEmpleado', value: this.otrosEntity.RolEmpleado + "" },
                    { name: 'CodigoRamo', value: this.otrosEntity.CodigoRamo + "" },
                    { name: 'CodigoAseguradora', value: this.otrosEntity.CodigoAseguradora + "" },
                    { name: 'BienAsegurado', value: this.otrosEntity.BienAsegurado + "" },
                    { name: 'Observaciones', value: this.otrosEntity.Observaciones + "" }
                );

                this.uploaderInc.uploadItem(this.uploaderInc.getNotUploadedItems()[0]);
            } else if (this.uploaderInc.queue.length > 1) {
                this.uploadAllFiles(tipoSolicitud);
                this.uploaderInc.clearQueue();
            }
        }
        else { //otros mov
            if (this.uploaderOtros.getNotUploadedItems().length == 1) {

                this.uploaderOtros.options.headers.push(
                    { name: 'Authorization', value: 'Token ' + this.sesionStorageService.retrieve("Token") },
                    { name: 'CodigoUsuario', value: this.usuario.CodigoUsuario + "" },
                    { name: 'CodigoCiudad', value: this.otrosEntity.CodigoCiudad + "" },
                    { name: 'CodigoCliente', value: this.otrosEntity.CodigoCliente + "" },
                    { name: 'CodigoPoliza', value: this.otrosEntity.CodigoPoliza + "" },
                    { name: 'RolEmpleado', value: this.otrosEntity.RolEmpleado + "" },
                    { name: 'CodigoRamo', value: this.otrosEntity.CodigoRamo + "" },
                    { name: 'CodigoAseguradora', value: this.otrosEntity.CodigoAseguradora + "" },
                    { name: 'BienAsegurado', value: this.otrosEntity.BienAsegurado + "" },
                    { name: 'Observaciones', value: this.otrosEntity.Observaciones + "" }
                );

                this.uploaderOtros.uploadItem(this.uploaderOtros.getNotUploadedItems()[0]);
            } else if (this.uploaderOtros.queue.length > 1) {
                this.uploadAllFiles(tipoSolicitud);
                this.uploaderOtros.clearQueue();
            }
        }

    }

    uploadAllFiles(tipoSolicitud: number): void {
        const xhr = new XMLHttpRequest();
        const form = new FormData();

        if (tipoSolicitud == 1) //inclusión
        {
            for (const fileItem of this.uploaderInc.getNotUploadedItems()) {
                form.append(fileItem.file.name, fileItem._file, fileItem.file.name);
            }

            xhr.onreadystatechange = (function () {
                if (xhr.readyState === 4) {
                    this.devolverMensaje(xhr.status,1);
                }
            }).bind(this);
            xhr.open("post", this.url + '/incluirOtros', true);
            xhr.setRequestHeader("enctype", "multipart/form-data");
            // IE workaround for Cache issues
            xhr.setRequestHeader("Cache-Control", "no-cache");
            xhr.setRequestHeader("Cache-Control", "no-store");
            xhr.setRequestHeader("Pragma", "no-cache");
            xhr.setRequestHeader("Authorization", "Token " + this.sesionStorageService.retrieve("Token"));
            xhr.setRequestHeader("CodigoUsuario", this.usuario.CodigoUsuario + "");
            xhr.setRequestHeader("CodigoCiudad", this.otrosEntity.CodigoCiudad + "");
            xhr.setRequestHeader("CodigoCliente", this.otrosEntity.CodigoCliente + "");
            xhr.setRequestHeader("CodigoPoliza", this.otrosEntity.CodigoPoliza + "");
            xhr.setRequestHeader("RolEmpleado", this.otrosEntity.RolEmpleado + "");
            xhr.setRequestHeader("CodigoRamo", this.otrosEntity.CodigoRamo + "");
            xhr.setRequestHeader("CodigoAseguradora", this.otrosEntity.CodigoAseguradora + "");
            xhr.setRequestHeader("BienAsegurado", this.otrosEntity.BienAsegurado + "");
            
            xhr.send(form);

        }

        else //otros movimientos
        {
            for (const fileItem of this.uploaderOtros.getNotUploadedItems()) {
                form.append(fileItem.file.name, fileItem._file, fileItem.file.name);
            }

            xhr.onreadystatechange = (function () {
                if (xhr.readyState === 4) {
                    this.devolverMensaje(xhr.status,2);
                }
            }).bind(this);
            xhr.open("post", this.url + '/otrosMov', true);
            xhr.setRequestHeader("enctype", "multipart/form-data");
            // IE workaround for Cache issues
            xhr.setRequestHeader("Cache-Control", "no-cache");
            xhr.setRequestHeader("Cache-Control", "no-store");
            xhr.setRequestHeader("Pragma", "no-cache");
            xhr.setRequestHeader("Authorization", "Token " + this.sesionStorageService.retrieve("Token"));
            xhr.setRequestHeader("CodigoUsuario", this.usuario.CodigoUsuario + "");
            xhr.setRequestHeader("CodigoCiudad", this.otrosEntity.CodigoCiudad + "");
            xhr.setRequestHeader("CodigoCliente", this.otrosEntity.CodigoCliente + "");
            xhr.setRequestHeader("CodigoPoliza", this.otrosEntity.CodigoPoliza + "");
            xhr.setRequestHeader("RolEmpleado", this.otrosEntity.RolEmpleado + "");
            xhr.setRequestHeader("CodigoRamo", this.otrosEntity.CodigoRamo + "");
            xhr.setRequestHeader("CodigoAseguradora", this.otrosEntity.CodigoAseguradora + "");
            xhr.setRequestHeader("BienAsegurado", this.otrosEntity.BienAsegurado + "");
            xhr.setRequestHeader("Observaciones", this.otrosEntity.Observaciones + "");
            xhr.send(form);
        }

    };    


    ngOnChanges() {
        this.showLoader = "sk-loading";

        /*correctHeight();
        detectBody();*/

        this.otrosEntity.CodigoCiudad = this.polizaContratada.CodigoCiudad;
        this.otrosEntity.CodigoCliente = this.polizaContratada.CodigoCliente;
        this.otrosEntity.CodigoPoliza = this.polizaContratada.CodigoPoliza;
        this.otrosEntity.RolEmpleado = this.polizaContratada.RolEmpleado;
        this.otrosEntity.CodigoRamo = this.polizaContratada.CodigoRamo;
        this.otrosEntity.CodigoAseguradora = this.polizaContratada.CodigoAseguradora;        

        this.usuario = jQuery.parseJSON(this.sesionStorageService.retrieve("usuario"));
        if (this.usuario == null) {
            let error = { "status": 998, "message": "Acceso denegado" };
            this.handleError.redirectUrl(error)
        } else {
            let bandera = this.sessionTokenService.useJwtHelper();
            if (!bandera) {
                let a = 1;
                this.exclusionEquiposService.consultaEquipos(this.polizaContratada).subscribe(
                    datosEquipos => {                        
                        this.cabEquipos = datosEquipos;                        
                        this.equipos = this.cabEquipos.EquipoExclusion;
                    },
                    error => { this.handleError.redirectUrl(error); });
            }
        }
    }

}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/solicitudes/solicitud-equipo.component.ts